export const globalTypes = {
    INITIALIZE: 'GLOBAL.INITIALIZE',
};
